module.exports = __webpack_public_path__ + "img/buyHomeBanner.ceac65a6.png";